import {closeModal, openModal} from "../../utils/common";

export default class Abstract {
  item;
  form;
  #frontElement;
  #closeModalButton;
  #callback = {};

  FillableTextElementType = {};
  textValue = {};
  fillableBlockElement;

  constructor(item) {
    this.item = item;
    this.form = this.item.querySelector(`.js-personal-form`);
    this.#frontElement = this.item.querySelector(`.js-personal-open`);
    this.#closeModalButton = this.item.querySelector(`.js-personal-close`);
    this.fillableBlockElement = this.item.querySelector(`.js-personal-fill-input`);

    this.watchOpenModalButtonClickHandler = this.watchOpenModalButtonClickHandler.bind(this);
    this.watchCloseModalButtonClickHandler = this.watchCloseModalButtonClickHandler.bind(this);
    this.watchSubmitForm = this.watchSubmitForm.bind(this);
    this.watchChangeForm = this.watchChangeForm.bind(this);
  }

  showForm() {
    openModal(this.form, `flex`);
  }

  hideForm() {
    closeModal(this.form);
  }

  getSubmitStatus() {
    return false;
  }

  submitForm(evt) {
    if (!this.getSubmitStatus()) {
      evt.preventDefault();
    }
  }

  fillTextElements() {}

  changeRadioValue(evt) {
    const self = evt.currentTarget;
    const target = evt.target;

    if (target.classList.contains(`js-personal-radio`)) {
      if (target.value !== `add`) {
        this.fillableBlockElement.setAttribute(`disabled`, `disabled`);
        this.setAddressInputsFromRadio(target);
      } else {
        this.fillableBlockElement.removeAttribute(`disabled`);
        this.#clearAddressInputs();
      }
    }
  }

  setAddressInputsFromRadio(radio) {
    Array.from(this.fillableBlockElement.elements).forEach(
      (input) => (input.value = radio.dataset[this.FillableTextElementType[input.dataset.inputFillName]]),
    );
  }

  #clearAddressInputs() {
    Array.from(this.fillableBlockElement.elements).forEach((input) => (input.value = ``));
  }

  watchSubmitForm(evt) {
    this.#callback.submitForm(evt);
  }

  watchChangeForm(evt) {
    this.#callback.changeForm(evt);
  }

  watchOpenModalButtonClickHandler(evt) {
    this.#callback.openModalButtonClick(evt);
  }

  watchCloseModalButtonClickHandler(evt) {
    this.#callback.closeButtonClick(evt);
  }

  setFormSubmitHandler(callback) {
    this.#callback.submitForm = callback;
    this.form.addEventListener(`submit`, this.watchSubmitForm);
  }

  setFormChangeHandler(callback) {
    this.#callback.changeForm = callback;
    this.form.addEventListener(`change`, this.watchChangeForm);
  }

  setOpenModalButtonClickHandler(callback) {
    this.#callback.openModalButtonClick = callback;
    this.#frontElement.addEventListener(`click`, this.watchOpenModalButtonClickHandler);
  }

  setCloseButtonClickHandler(callback) {
    this.#callback.closeButtonClick = callback;
    this.#closeModalButton.addEventListener(`click`, this.watchCloseModalButtonClickHandler);
  }
}
